import React from "react";
interface props {
  className?: string;
}
function TwitterSvg({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      className={className}
      fill="none"
      viewBox="0 0 21 20"
    >
      <g clipPath="url(#clip0_1181_936)" opacity="0.8">
        <mask
          id="mask0_1181_936"
          style={{ maskType: "luminance" }}
          width="21"
          height="20"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M.337 0h19.89v19.889H.336V0z"></path>
        </mask>
        <g mask="url(#mask0_1181_936)">
          <path
            fill="#fff"
            d="M14.728 2.21H17.1l-5.182 6.553 6.097 8.917h-4.773L9.5 12.273 5.224 17.68H2.85l5.542-7.01-5.846-8.458H7.44l3.377 4.942 3.91-4.943zm-.834 13.9h1.315L6.723 3.7h-1.41l8.58 12.41z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1181_936">
          <path
            fill="#fff"
            d="M0 0H19.889V19.889H0z"
            transform="translate(.332)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default TwitterSvg;
